import { Platform, StyleSheet } from 'react-native'
import type { Theme } from '../../../theme/getTheme'

export function getEnterpriseContactScreenStyles(theme: Theme) {
  return StyleSheet.create({
    // ── Web root (document scroll) ──────────────────────────────────────
    webPageRoot: {
      width: '100%' as never,
      minHeight: '100vh' as never,
      backgroundColor: theme.background.primary,
    },

    // ── Native root ──────────────────────────────────────────────────────
    root: {
      flex: 1,
      backgroundColor: theme.background.primary,
    },
    scroll: {
      flex: 1,
      backgroundColor: theme.background.primary,
    },
    scrollContent: {
      paddingBottom: theme.spacing.xxxl,
    },

    // ── Top bar (back button row) ────────────────────────────────────────
    topBar: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: theme.spacing.huge,
      paddingTop: theme.spacing.md,
      paddingBottom: theme.spacing.sm,
      borderBottomWidth: 1,
      borderBottomColor: theme.gray[200],
      maxWidth: 1200,
      width: '100%',
      alignSelf: 'center',
    },
    backButton: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing.sm,
      minHeight: theme.touchTargets.minHeight,
      paddingVertical: theme.spacing.sm,
      paddingRight: theme.spacing.lg,
    },
    backButtonPressed: {
      opacity: 0.75,
    },
    backButtonHoverWeb: {
      opacity: 0.9,
    },
    backLabel: {
      ...theme.typography.label,
      color: theme.primary,
      fontWeight: '700',
    },

    // ── Section wrapper (mirrors LandingCtaBand section) ─────────────────
    section: {
      paddingHorizontal: 24,
      paddingVertical: 48,
    },
    sectionPhone: {
      paddingHorizontal: 16,
      paddingVertical: 34,
    },

    // ── Two-column card (mirrors LandingCtaBand contactCard) ─────────────
    card: {
      maxWidth: 1720,
      marginHorizontal: 'auto' as unknown as number,
      width: '100%',
      backgroundColor: '#1A202C',
      borderRadius: 28,
      padding: Platform.OS === 'web' ? 54 : 30,
      flexDirection: Platform.OS === 'web' ? 'row' : 'column',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      gap: 36,
    },
    cardStacked: {
      flexDirection: 'column',
    },
    cardPhone: {
      borderRadius: 22,
      padding: 18,
      gap: 24,
    },

    // ── Left copy column ─────────────────────────────────────────────────
    copy: {
      flex: Platform.OS === 'web' ? 0.9 : undefined,
      maxWidth: 520,
    },
    copyStacked: {
      flex: 0,
      maxWidth: 680,
      width: '100%',
    },
    copyPhone: {
      maxWidth: '100%' as unknown as number,
      width: '100%',
    },

    badge: {
      flexDirection: 'row',
      alignItems: 'center',
      alignSelf: 'flex-start',
      gap: 8,
      borderRadius: 999,
      paddingVertical: 6,
      paddingHorizontal: 12,
      backgroundColor: 'rgba(107, 70, 193, 0.18)',
      marginBottom: 14,
    },
    badgeText: {
      fontSize: 12,
      fontWeight: '700',
      color: '#D6BCFA',
      letterSpacing: 0.3,
      textTransform: 'uppercase',
    },

    title: {
      fontSize: Platform.OS === 'web' ? 36 : 26,
      fontWeight: '700',
      lineHeight: Platform.OS === 'web' ? 43 : 32,
      letterSpacing: -0.8,
      color: '#FFFFFF',
      marginBottom: 14,
    },
    titlePhone: {
      fontSize: 24,
      lineHeight: 30,
      letterSpacing: -0.5,
    },

    tagline: {
      fontSize: 17,
      lineHeight: 26,
      color: 'rgba(255, 255, 255, 0.75)',
    },
    taglineStacked: {
      maxWidth: 620,
    },
    taglinePhone: {
      fontSize: 15,
      lineHeight: 23,
    },

    // ── Right form column ─────────────────────────────────────────────────
    formWrap: {
      flex: Platform.OS === 'web' ? 1.1 : undefined,
      width: '100%',
      backgroundColor: '#111827',
      borderWidth: 1,
      borderColor: 'rgba(159, 122, 234, 0.24)',
      borderRadius: 20,
      padding: Platform.OS === 'web' ? 24 : 16,
    },
    formWrapPhone: {
      borderRadius: 16,
      padding: 14,
    },
  })
}
